export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/award.e495d58b.svg","height":175,"width":175,"blurWidth":0,"blurHeight":0};